<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('assistanceMoneyDetail.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="assistanceMoneyDetailInfo.conditions" class="query-form">
        <el-form-item>
          <el-input 
            v-model="assistanceMoneyDetailInfo.conditions.orderId"
            :placeholder="$t('assistanceMoneyDetail.orderIdPlaceholder')" 
            clearable 
            style="width: 200px" />
        </el-form-item>
        <el-form-item>
          <el-input 
            v-model="assistanceMoneyDetailInfo.conditions.userName"
            :placeholder="$t('assistanceMoneyDetail.userNamePlaceholder')" 
            clearable 
            style="width: 150px" />
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="assistanceMoneyDetailInfo.conditions.tradeType"
            :placeholder="$t('assistanceMoneyDetail.tradeTypePlaceholder')" 
            clearable
            style="width: 150px">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('assistanceMoneyDetail.tradeType1')" value="1" />
            <el-option :label="$t('assistanceMoneyDetail.tradeType2')" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="assistanceMoneyDetailInfo.conditions.statusCd"
            :placeholder="$t('assistanceMoneyDetail.statusPlaceholder')" 
            clearable
            style="width: 150px">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('assistanceMoneyDetail.status0')" value="0" />
            <el-option :label="$t('assistanceMoneyDetail.status1')" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_queryAssistanceMoneyDetailMethod">
            {{ $t('assistanceMoneyDetail.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('assistanceMoneyDetail.title') }}</span>
      </div>
      <el-table :data="assistanceMoneyDetailInfo.details" border style="width: 100%">
        <el-table-column prop="detailId" :label="$t('assistanceMoneyDetail.detailId')" align="center" width="100" />
       <!--  <el-table-column prop="assistanceMoneyId" :label="$t('assistanceMoneyDetail.assistanceMoneyId')" align="center" width="120" /> -->
        <!-- <el-table-column prop="userId" :label="$t('assistanceMoneyDetail.userId')" align="center" width="100" /> -->
         <el-table-column prop="userName" :label="$t('assistanceMoneyDetail.userName')" align="center" width="100" />
        <el-table-column prop="orderId" :label="$t('assistanceMoneyDetail.orderId')" align="center" width="120" />
        <el-table-column prop="tradeType" :label="$t('assistanceMoneyDetail.tradeType')" align="center" width="100">
          <template slot-scope="scope">
            {{ getTradeTypeLabel(scope.row.tradeType) }}
          </template>
        </el-table-column>
        <el-table-column prop="tradeAmount" :label="$t('assistanceMoneyDetail.tradeAmount')" align="center" width="120" />
        <el-table-column prop="beforeAmount" :label="$t('assistanceMoneyDetail.beforeAmount')" align="center" width="120" />
        <el-table-column prop="afterAmount" :label="$t('assistanceMoneyDetail.afterAmount')" align="center" width="120" />
        <el-table-column prop="tradeFlow" :label="$t('assistanceMoneyDetail.tradeFlow')" align="center" width="150" />
        <el-table-column prop="tradeDesc" :label="$t('assistanceMoneyDetail.tradeDesc')" align="center" />
        <el-table-column prop="statusCd" :label="$t('assistanceMoneyDetail.status')" align="center" width="100">
          <template slot-scope="scope">
            {{ getStatusLabel(scope.row.statusCd) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination 
        @current-change="handleCurrentChange" 
        :current-page="assistanceMoneyDetailInfo.conditions.page"
        :page-size="assistanceMoneyDetailInfo.conditions.row" 
        layout="total, prev, pager, next"
        :total="assistanceMoneyDetailInfo.total" 
        class="pagination" />
    </el-card>
  </div>
</template>

<script>
import { listAssistanceMoneyDetails } from '@/api/order/assistanceMoneyApi'

export default {
  name: 'AssistanceMoneyDetail',
  data() {
    return {
      assistanceMoneyDetailInfo: {
        details: [],
        total: 0,
        conditions: {
          orderId: '',
          userId: '',
          userName: '',
          tradeType: '',
          statusCd: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAssistanceMoneyDetails(1, 10)
  },
  methods: {
    async _listAssistanceMoneyDetails(page, rows) {
      this.assistanceMoneyDetailInfo.conditions.page = page
      this.assistanceMoneyDetailInfo.conditions.row = rows

      try {
        const res = await listAssistanceMoneyDetails(this.assistanceMoneyDetailInfo.conditions)
        if (res.code === 0 || res.code === '0') {
          this.assistanceMoneyDetailInfo.total = res.total
          this.assistanceMoneyDetailInfo.details = res.data || []
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryAssistanceMoneyDetailMethod() {
      this._listAssistanceMoneyDetails(1, 10)
    },
    handleCurrentChange(val) {
      this._listAssistanceMoneyDetails(val, this.assistanceMoneyDetailInfo.conditions.row)
    },
    getTradeTypeLabel(type) {
      const typeMap = {
        '1': this.$t('assistanceMoneyDetail.tradeType1'),
        '2': this.$t('assistanceMoneyDetail.tradeType2')
      }
      return typeMap[type] || type
    },
    getStatusLabel(status) {
      const statusMap = {
        '0': this.$t('assistanceMoneyDetail.status0'),
        '1': this.$t('assistanceMoneyDetail.status1')
      }
      return statusMap[status] || status
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.query-form {
  text-align: left;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>